"use strict";
'use es6'; // eslint-disable-next-line no-unused-vars

require("transmute/__index__");

require("atom");

require("atom/connect");

require("autolinker");

require("Backbone");

require("classnames");

require("I18n");

require("I18n/init/data/currency");

require("I18n/init/data/baseLocales");

require("I18n/init/data/publicLocales");

require("I18n/init/data/allTimezones");

require("I18n/init/providers/createStandardI18nProvider");

require("I18n/init/register/sync/registerAllData");

require("immutable");

require("planout");

require("q");

require("react");

require("react-addons-pure-render-mixin");

require("react-addons-shallow-compare");

require("react-addons-css-transition-group");

require("react-dnd");

require("react-dnd-html5-backend");

require("ReactDnDHTML5Backend");

require("react-dom");

require("react-immutable-proptypes");

require("react-immutable-render-mixin");

require("react-redux");

require("react-input-autosize");

require("react-select-plus");

require("react-virtualized");

require("redux");

require("redux-thunk");

require("sanitize");

require("Sanitize");

require("styled-components");

require("Tether");

require("draft-js");

require("draft-extend");

require("draft-convert");

require("general-store");

require("hoist-non-react-statics");

require("apollo-client");

require("apollo-link");

require("apollo-cache-inmemory");

require("graphql-tag");

require("graphql/language/printer");

require("@apollo/react-components");

require("@apollo/react-hoc");

require("@apollo/react-hooks");

require("@apollo/react-common");

function importAll(r) {
  r.keys().forEach(r);
}

importAll(require.context('I18n/static/js/utils', true, /\.js$/));
importAll(require.context('I18n/static/js/components', true, /\.js$/));
importAll(require.context('I18n/static/js/constants/regex', true, /\.js$/));